<template>
  <transition name="modal" appear>
    <div class="modal">
      <div class="modal-bg" @click.self="$emit('close')">
        <div class="modal-panel" :class="[className, { 'modal-point-scan': $slots.point, 'custom-panel': isScrollModal }]">
          <div class="modal-identify" v-if="$slots.identify">
            <slot name="identify"></slot>
          </div>
          <div class="modal-point" v-if="$slots.point">
            <slot name="point"></slot>
          </div>
          <div class="modal-header" v-if="$slots.headline">
            <h4 class="modal-headline"><slot name="headline"></slot></h4>
          </div>
          <div class="modal-header-content" v-if="$slots.headerContent">
            <slot name="headerContent"></slot>
          </div>
          <div class="modal-body" v-if="$slots.body" :class="{ 'custom-modal-body': isCustomModalBody }">
            <slot name="body"></slot>
          </div>
          <div class="modal-footer" v-if="$slots.footer">
            <slot name="footer"></slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';

defineProps({
  className: String,
  isScrollModal: {
    type: Boolean,
    default: false,
  },
  isCustomModalBody: {
    type: Boolean,
    default: false,
  }
});

defineEmits(['close']);
</script>

<style scoped>
.custom-panel {
  display: flex;
  flex-direction: column;
  max-height: 300px;
}
.modal-search-bank {
  padding: 45px 0 35px;
}

.modal-sms {
  padding: 35px 20px;
}

.modal-scroll {
  overflow-y: auto;
}

.custom-modal-body {
  margin-bottom: 20px !important;
}

.modal-small .modal-scroll {
  max-height: calc(100% - 50px) !important;
}

.modal-enter-from,
.modal-leave-to {
  transform: translateY(10px);
  opacity: 0;
}

.modal-header-content {
  text-align: center;
  margin-bottom: 25px;
}

.modal-confirm {
  max-height: calc(100% - 88px) !important;
  overflow-y: auto;
}

@media (max-width: 360px) {
  .modal-small .modal-scroll {
    width: calc(100% - 40px) !important;
  }
}

@media (max-height: 640px) {
  .modal-panel {
    padding-top: 30px !important;
    padding-bottom: 30px !important;
  }
}

@media (max-width: 320px) {
  .modal-small .modal-scroll {
    width: calc(100% - 20px) !important;
  }
}
</style>
